// Client de GET /api/analyze/estimate (NutriScan 10, § « Coût annoncé avant de lancer ») : le lot
// doit connaître son coût — et savoir si le budget du jour suffit — AVANT de démarrer, jamais au
// milieu (api/src/routes/estimate.ts, api/src/budgetGuard.ts).
export class EstimationError extends Error {}

export interface EstimationImport {
  nbPhotos: number;
  modele: string;
  /** `null` quand le modèle configuré n'a pas de ligne dans `eval/pricing.json` (route estimate.ts) :
   *  un coût inconnu, pas une erreur — l'écran d'import doit rester utilisable. */
  coutParPhotoEur: number | null;
  coutTotalEstimeEur: number | null;
  cumulEur: number;
  /** 0 ou négatif = garde-fou budgétaire désactivé (api/src/budgetGuard.ts). */
  plafondEur: number;
  budgetSuffisant: boolean;
}

export interface OptionsEstimation {
  baseUrl?: string;
  signal?: AbortSignal;
  fetchImpl?: typeof fetch;
  /** Millisecondes avant abandon (défaut 8000) — une estimation qui ne répond jamais ne doit pas
   *  bloquer indéfiniment « Démarrer l'import » (incident : requête pendante, bouton resté désactivé
   *  sans message). */
  timeoutMs?: number;
}

export async function estimerImport(nbPhotos: number, options: OptionsEstimation = {}): Promise<EstimationImport> {
  const fetchImpl = options.fetchImpl ?? fetch;
  const signalTimeout = AbortSignal.timeout(options.timeoutMs ?? 8000);
  const signal = options.signal ? AbortSignal.any([options.signal, signalTimeout]) : signalTimeout;
  let reponse: Response;
  try {
    reponse = await fetchImpl(`${options.baseUrl ?? ''}/api/analyze/estimate?nbPhotos=${nbPhotos}`, {
      signal,
    });
  } catch {
    throw new EstimationError("Impossible de joindre NutriScan pour estimer le coût de l'import.");
  }
  if (!reponse.ok) {
    throw new EstimationError("L'estimation du coût de l'import est indisponible pour le moment.");
  }
  return (await reponse.json()) as EstimationImport;
}
